import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { TOURIST_PLAN_GROUPS, planStepsForRail } from '../../data/touristNavigation';

function PlanStepsRail({ activeStepId, className = '' }) {
	const railRef = useRef(null);
	const activeRef = useRef(null);

	useEffect(() => {
		if (activeRef.current && railRef.current) {
			const rail = railRef.current;
			const active = activeRef.current;
			const offset = active.offsetLeft - rail.offsetWidth / 2 + active.offsetWidth / 2;
			rail.scrollTo({ left: Math.max(0, offset), behavior: 'smooth' });
		}
	}, [activeStepId]);

	return (
		<div className={`plan-steps-rail${className ? ` ${className}` : ''}`} ref={railRef}>
			{TOURIST_PLAN_GROUPS.map((group, groupIndex) => (
				<div key={group.id} className="plan-steps-rail__group">
					{groupIndex > 0 && <span className="plan-steps-rail__divider" aria-hidden="true" />}
					{planStepsForRail(group.steps).map((step) => (
						<Link
							key={step.id}
							ref={activeStepId === step.id ? activeRef : null}
							to={step.route}
							className={`plan-steps-rail__step${activeStepId === step.id ? ' is-active' : ''}${step.highlight ? ' is-featured' : ''}`}
							aria-current={activeStepId === step.id ? 'page' : undefined}
						>
							{step.label}
						</Link>
					))}
				</div>
			))}
		</div>
	);
}

export default PlanStepsRail;
